import * as LicensesConstants from "../constants/Providers";

const initialState = {
  collection: [],
  isFetching: false
};

export function providers(state = initialState, action) {
  switch (action.type) {
    case LicensesConstants.FETCH_PROVIDERS_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case LicensesConstants.FETCH_PROVIDERS_COMPLETED:
      return Object.assign({}, state, {
        collection: action.providers,
        isFetching: false
      });
    default:
      return state;
  }
}
